<template>
  <div class="toggle-tab">
    <div class="toggle-tab-inner">
      <div class="btn-check-wrap" :class="modelValue === firstMenu ? 'check01' : 'check02'">
        <button @click="fnClick(firstMenu)">{{ firstMenu }}</button>
        <button @click="fnClick(secondMenu)">{{ secondMenu }}</button>
      </div>
    </div>
  </div>
</template>
<script setup>
const emits = defineEmits(['update:modelValue']);
const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  firstMenu: {
    type: String,
    default: ''
  },
  secondMenu: {
    type: String,
    default: ''
  }
});

const fnClick = value => {
  emits('update:modelValue', value);
};
</script>
<style scoped></style>
